import IntegrationsModalView from './IntegrationsModal.View';
import { IntegrationsModalBaseProps } from './types';

const IntegrationsModal: React.FC<IntegrationsModalBaseProps> = (props) => {
  const { children } = props;
  return <IntegrationsModalView {...props}>{children}</IntegrationsModalView>;
};

export default IntegrationsModal;
